<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="app-title">
      <div>
        <h1><i class="fas fa-building"></i> หน่วยงาน</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">หน่วยงานทั้งหมด</h3>
            <p>
              <button @click="openAdd" type="button" class="btn btn-primary">
                <i class="fas fa-plus"></i> เพิ่มหน่วยงาน
              </button>
            </p>
          </div>
          <div class="tile-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  placeholder="🔍 ค้นหาหน่วยงาน..."
                />
              </div>
            </div>
            <p class="text-muted">
              ทั้งหมด {{ filteredDepartments.length }} รายการ
            </p>
            <table class="table table-bordered" v-if="departments.length">
              <thead class="bg-light">
                <tr>
                  <th>#</th>
                  <th>name</th>
                  <th>manage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!filteredDepartments.length">
                  <td colspan="3" class="text-center text-muted">
                    ไม่มีข้อมูลหน่วยงาน
                  </td>
                </tr>
                <tr v-for="(item, index) in filteredDepartments" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.department_name }}</td>
                  <td>
                    <div
                      class="btn-group btn-group-sm"
                      role="group"
                      aria-label="Basic mixed styles example"
                    >
                      <button
                        @click="edit(item)"
                        type="button"
                        class="btn btn-warning"
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        @click="del(item.id)"
                        type="button"
                        class="btn btn-danger"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ข้อมูลหน่วยงาน</h5>
            <button
              @click="modal.hide()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="handleSubmit"
              ref="form"
              class="needs-validation"
              novalidate
            >
              <div class="form-group">
                <label for="">ชื่อหน่วยงาน</label>
                <input
                  v-model="data.department_name"
                  type="text"
                  class="form-control"
                  placeholder="ชื่อหน่วยงาน"
                  required
                />
                <div class="invalid-feedback">Required.</div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              v-if="!is_edit"
              @click="handleSubmit"
              type="button"
              class="btn btn-primary"
            >
              <i class="fas fa-save"></i>
              บันทึกข้อมูล
            </button>
            <button
              v-else
              @click="update"
              type="button"
              class="btn btn-warning"
            >
              <i class="fas fa-edit"></i>

              แก้ไขข้อมูล
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="modal.hide()"
            >
              <i class="fas fa-times"></i>

              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import DapartmentsService from "../services/departments.service";
export default {
  data() {
    return {
      modal: null,
      data: {
        id: null,
        department_name: "",
      },
      is_edit: false,
      isLoading: false,
      departments: [],
      search: "",
      name: this.$route.name,
    };
  },
  computed: {
    filteredDepartments() {
      if (!this.search) {
        return this.departments;
      }

      return this.departments.filter((item) =>
        item.department_name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    openAdd() {
      this.data = {
        department_name: "",
      };
      this.is_edit = false;
      this.$refs.form?.classList.remove("was-validated");
      this.modal.show();
    },
    clear() {
      this.data = {
        department_name: "",
      };
      this.is_edit = false;
    },
    insert() {
      DapartmentsService.create(this.data)
        .then((res) => {
          this.showSuccess();
          this.clear();
          this.get();
        })
        .catch((err) => {});
    },
    update() {
      DapartmentsService.update(this.data.id, this.data)
        .then((res) => {
          this.showUpdate();
          this.get();
          this.clear();
        })
        .catch((err) => {});
    },
    edit(data) {
      this.modal.show();
      this.data = JSON.parse(JSON.stringify(data));
      this.is_edit = true;
    },
    remove(id) {
      DapartmentsService.delete(id)
        .then((res) => {
          this.showDelete();
          this.get();
          this.clear();
        })
        .catch((err) => {});
    },
    async del(id) {
      const confirm = await this.showConfirm();
      confirm ? this.remove(id) : false;
    },
    get() {
      DapartmentsService.getAll()
        .then((res) => {
          this.departments = res.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        this.$refs.form.classList.add("was-validated");
        return;
      }

      this.is_edit ? this.update() : this.insert();

      this.modal.hide();
      this.clear();
      this.$refs.form.classList.remove("was-validated");
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.exampleModal);
  },
  created() {
    this.isLoading = true;
    this.get();
  },
};
</script>

<style>
</style>